export const toggleSidebar = status => {
    return {
        type: 'TOGGLE_SIDEBAR',
        status: status
    }
};

